"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalNTPSourcesDialogToggle = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const ModalDialogsContext_1 = require("./ModalDialogsContext");
const AdditionalNTPSourcesDialogToggle = () => {
    const { additionalNTPSourcesDialog: { open }, } = (0, ModalDialogsContext_1.useModalDialogsContext)();
    return react_1.default.createElement(react_core_1.AlertActionLink, { onClick: () => open() }, "Add NTP sources");
};
exports.AdditionalNTPSourcesDialogToggle = AdditionalNTPSourcesDialogToggle;
//# sourceMappingURL=AdditionaNTPSourceDialogToggle.js.map